export default "__VITE_ASSET__59MHWRok__"